module.exports = __webpack_public_path__ + "media/images/partners/PCC-ee9d7e6160e869a554ebf632cd376e2c.png";